// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  identity: __t.identity().primaryKey(),
  social: __t.u8(),
  fun: __t.u8(),
  creativity: __t.u8(),
  rest: __t.u8(),
  visSocial: __t.bool().name("vis_social"),
  visFun: __t.bool().name("vis_fun"),
  visCreativity: __t.bool().name("vis_creativity"),
  visRest: __t.bool().name("vis_rest"),
  updatedAt: __t.timestamp().name("updated_at"),
});
